import React, { useEffect } from 'react';
import styles from 'assets/css/Card.module.css';
import { usePackeryLoading, useEmitterListener, USE_RETRIEVE_DATA_EVENTS } from '@ace/react-utilities';
import classNames from 'classnames';
import { useQueryClient } from 'react-query';

export default function withPackeryCard(Component) {
    function WithPackeryCard({additionalClassNames, ...props}) {
        const { addChildFn, triggerChildLoadFn } = usePackeryLoading();
        const queryClient = useQueryClient();

        useEffect(() => {
            //console.log(`[withPackeryCard] addChildFn('${props.componentName}')`);
            addChildFn(props.componentName);
        }, [addChildFn, props.componentName]);

        /* used to trigger successful load for non-stale components (components with infinite staleTime won't re-fetch) on re-render (when swapping back and forth between tabs) */
        useEffect(() => {
            var queryState = queryClient.getQueryState([props.componentName, props.retrievalUrl])
            if (!queryState?.isFetching && queryState?.status === "success") {
                //console.log(`[withPackeryCard] checkQueryStatus + triggerChildLoadFn('${props.componentName}')`);
                triggerChildLoadFn(props.componentName);
            }
        }, [triggerChildLoadFn, props.componentName, props.retrievalUrl, queryClient]);

        useEmitterListener(props.componentName, USE_RETRIEVE_DATA_EVENTS.ON_FETCH_SUCCESS, 
            (data) => {
                //console.log(`<useEmitterListener> [withPackeryCard] triggerChildLoadFn('${props.componentName}')`);
                triggerChildLoadFn(props.componentName);
            }
        );

        const cardProps = {
            ...props,
            additionalClassNames: classNames(additionalClassNames, styles.draggable),
            draggable: true
        };

        return (
            <div className={`grid-item`} data-item-id={props.dashboardVariantCardRetrievalID}>
                <Component {...cardProps} />
            </div>
        )
    }

    return WithPackeryCard;
}